import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorDto } from 'src/app/shared/models/app.models';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { Utils } from 'src/app/shared/helpers/utils.helper';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { ValidateUserDTO } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { AuthenticationActions } from '../models/authentication-actions.enum';
import { ToastService } from 'src/app/shared/services/toast.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../../authentication/components/authentication/authentication.component.scss']
})
export class LoginComponent implements OnInit {
  //#region properties

  //#region private
  private _loginForm: FormGroup;
  invalidSubmit= false;
  errorsList : ErrorDto[] = [];
  returnUrl;
  translations = en;
  AppConstants = AppConstants;
  showPassword: boolean = false;
  //#endregion

  //#region public
  //#endregion

  //#endregion

  //#region getters
  public get loginForm(): FormGroup {
    return this._loginForm;
  }
  //#endregion

  //#region setters
  public set loginForm(value: FormGroup) {
    this._loginForm = value;
  }
  //#endregion

  //#region ctor
  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private toastService: ToastService
  ) { }
  //#endregion

  //#region life cycle hooks
  ngOnInit(): void {
    this.initialize();
    this._activeRoute.queryParams.subscribe(params => this.returnUrl = params['returnUrl']);
  }
  //#endregion



  //#region private actions

  //#region API Service
  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }
  //#endregion

  //#region Payloads
  private prepareValidateUserRequestPayload(data: any) {
    return data as ValidateUserDTO;
  }
  //#endregion

  //#region Fire HTTP Requests
  private fireValidateUserRequest(apiService: ApiService, payload: ValidateUserDTO) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.ACCOUNT, AppConstants.ACTIONS.AUTHENTICATE, true, environment.APIs_PREFIX, payload);

    // req$.subscribe({
    //   next: (response) => {
    //     console.log('API Response:', response);
    //   },
    //   error: (err) => {
    //     console.error('API Error:', err);
    //   }
    // });

    return lastValueFrom(req$);


  }
  //#endregion

  //#region initialization
  private initializeForm() {
    this._loginForm = this._formBuilder.group({
      Email: [environment.DISABLE_BACKEND ? 'vendor@demo.qa' : '', [Validators.required, Validators.email]],
      Password: [environment.DISABLE_BACKEND ? 'Demo@123' : '', [Validators.required, Validators.minLength(6)]]
    });
  }


  private initialize() {
    this.initializeForm();
  }
  //#endregion

  //#endregion

  //#region public actions

  //#region UI Helpers
  public onClickRegister() {
    // window.location.href = environment.NAS_REG_URL;
  }
  //#endregion

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  //#region form
  public isFormValid() {
    return this.loginForm.valid;
  }

  public onSubmitForm(event: Event) {


    event.preventDefault();
    this.invalidSubmit = false;
    this.errorsList= [];

    if(this.isFormValid()) {
      let data = this.loginForm.getRawValue();
      this.handleValidateUser(data);
    } else {
      this.markFormGroupTouched(this.loginForm);
      this.invalidSubmit =true;


    }
  }

  //#region Handlers
  private async handleValidateUser(data: any) {

    console.log('handleValidateUser called with data:', data); // Debug log
    this._loaderService.showLoader();
    const apiService = this.createApiService();
    const payload = this.prepareValidateUserRequestPayload(data);
    this.fireValidateUserRequest(apiService, payload)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {
       // this._userService.handleValidAuthentication(result);
        this._userService.email = data.Email;
        this._router.navigate(
          [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.OTP_Page],
          { queryParams: { action: AuthenticationActions.Login } }
        );


        // if(Utils.IsNullOrWhiteSpace(this._userService.user?.Id)) {
        //   this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.REGISTER])
        //   // location.href="authentication/introduction";
        // } else {

        //   // if (this.returnUrl){
        //   //   this._router.navigate([this.returnUrl]);
        //   // }
        //   // else{
        //   //   location.href="home/main";
        //   // }
        // }
      } else {
        
        if (this.isVerifyEmailError(result)) {
          this.showVerifyEmailPage(data.Email);
          return;
        }
        
        // Check if the error is related to email verification
        const isEmailVerificationError = result.errorMessageEn?.toLowerCase().includes('email is not verified') || 
                                         result.errorMessageEn?.toLowerCase().includes('verification link');
        
        if (isEmailVerificationError) {
          // Show as info/warning since a new verification link has been sent
          this.toastService.error(result.errorMessageEn);
        } else {
          this.toastService.error(result.errorMessageEn);
        }
        //this.formValidationService.setCustomError(this.loginForm.get('Email'), result.errorMessageEn);
      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
      this.invalidSubmit = true;
      this.errorsList = [];

      if (this.isVerifyEmailError(err.error)) {
        this.showVerifyEmailPage(data.Email);
      }

    })
    .finally(() => {
      this._loaderService.hideLoader();
    });
  }
  //#endregion

  private isVerifyEmailError(error: any): boolean {
    return Number(error?.code) === 7;
  }

  private showVerifyEmailPage(email: string): void {
    this._userService.email = email;
    this._router.navigate(
      [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.OTP_Page],
      { queryParams: { action: AuthenticationActions.VerifyEmail } }
    );
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  //#endregion

  //#endregion
}
